import { IBaseAction, IPromiseParam } from '../base';
import * as types from './actionTypes.organization';

export interface ICreateOrganizationParams {
    name: string
}

export const createOrganization = ({ name, resolve, reject }: ICreateOrganizationParams & IPromiseParam) => ({
    type: types.CREATE_ORGANIZATION_REQ,
    name,
    resolve,
    reject
});

export interface IUpdateOrganizationParams {
    name: string
}

export const updateOrganization = ({ name, resolve, reject }: IUpdateOrganizationParams & IPromiseParam) => ({
    type: types.UPDATE_ORGANIZATION_REQ,
    name,
    resolve,
    reject
});

export const removeOrganization = () => ({
    type: types.REMOVE_ORGANIZATION_REQ,
});

export interface IAddOrganizationMemberParams {
    email: string
}

export const addOrganizationMember = ({ email, resolve, reject }: IAddOrganizationMemberParams & IPromiseParam) => ({
    type: types.ADD_ORGANIZATION_MEMBER_REQ,
    email,
    resolve,
    reject
});

export interface IRemoveOrganizationMemberParams {
    email: string
}
export const removeOrganizationMember = ({ email, resolve, reject }: IRemoveOrganizationMemberParams & IPromiseParam) => ({
    type: types.REMOVE_ORGANIZATION_MEMBER_REQ,
    email,
    resolve,
    reject
});


export interface IVerifyOrganizationMemberParams {
    code: string
}
export const verifyOrganizationMember = ({ code, resolve, reject }: IVerifyOrganizationMemberParams & IPromiseParam) => ({
    type: types.VERIFY_ORGANIZATION_MEMBER_REQ,
    code,
    resolve,
    reject
});